import Folder from "./Folder";
import Page from "../Page";
import Api from "../Api";
import HttpClient from "../HttpClient";
import GetListFolderQuery from "./GetListFolderQuery";
import UpdateFolderPayload from "./UpdateFolderPayload";
import CreateFolderPayload from "./CreateFolderPayload";

// noinspection JSUnusedGlobalSymbols
/**
 * API Wrapper to work with folders.
 * @author Kacper Faber
 * @since 0.1.3
 */
class FolderApi {
    /**
     * Get paginated list of folders.
     * @author Kacper Faber
     * @since 0.1.3
     * @param query GetListFolderQuery
     */
    static getList(query: GetListFolderQuery): Promise<Page<Folder>> {
        const url = Api.getUrl('/api/folder/');
        return HttpClient.get(url, { ...query });
    }

    /**
     * Deletes Folder by ID
     * @param id Folder's to delete
     * @author Kacper Faber
     * @since 0.1.3
     */
    static deleteById(id: string | number): Promise<void> {
        const url = Api.getUrl(`/api/folder/${id}/`);
        return HttpClient.execNoContent(url, 'DELETE', {}, {});
    }

    /**
     * Deletes entity from database.
     * Given folder must contain valid id.
     * @param folder Folder entity with valid id.
     * @author Kacper Faber
     * @since 0.1.3
     */
    static delete(folder: Folder): Promise<void> {
        const url = Api.getUrl(`/api/folder/${folder.id}/`);
        return HttpClient.execNoContent(url, 'DELETE', {}, {});
    }

    /**
     * Updates resource by ID
     * @param id Resource ID
     * @param p UpdateFolderPayload
     * @author Kacper Faber
     * @since 0.1.4
     */
    static updateById(id: number, p: UpdateFolderPayload): Promise<void> {
        const url = Api.getUrl(`/api/folder/${id}/`);
        return HttpClient.put(url, {}, { ...p });
    }

    /**
     * Create new folder.
     * @author Kacper Faber
     * @param p CreateFolderPayload
     */
    static create(p: CreateFolderPayload): Promise<Folder> {
        const url = Api.getUrl(`/api/folder/`);
        return HttpClient.post(url, {}, { ...p });
    }
}

// noinspection JSUnusedGlobalSymbols
export default FolderApi;